<template>
  <SettingsPageTemplate>
    <template #heading>
      <h2>Car Brand List</h2>
      <button
        class="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#createModal"
      >
        Create Car Brand
      </button>
    </template>
    <template #default v-if="!isLoading">
      <CustomDataTable
        :searchParams="['cartype.name', 'name', 'status']"
        :filteredData="carBrandList"
        @fetchPaginatedData="fetchPaginatedData"
      >
        <table class="table table-hover table-bordered">
          <thead class="table-light">
            <tr>
              <th>SL</th>
              <th>Car Type</th>
              <th>Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="paginatedCarBrandList.length > 0">
              <tr
                v-for="(carBrand, index) in paginatedCarBrandList"
                :key="carBrand.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ carBrand.cartype.name }}</td>
                <td>{{ carBrand.name }}</td>
                <td>{{ carBrand.status }}</td>
                <td>
                  <button
                    class="btn btn-xs btn-primary"
                    style="margin-right: 5px"
                    data-bs-toggle="modal"
                    data-bs-target="#editModal"
                    @click="dataOnEdit = carBrand"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button
                    class="btn btn-xs btn-danger"
                    @click="deleteCarBrand(carBrand.id)"
                  >
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="50" class="text-center text-danger">
                  No Data Found!
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </CustomDataTable>
    </template>
    <template #createModal>
      <CreateForm
        :carTypeList="carTypeList"
        @refreshCarBrandList="getCarBrandList"
      ></CreateForm>
    </template>
    <template #editModal>
      <EditForm
        :carTypeList="carTypeList"
        :carBrand="dataOnEdit"
        @refreshCarBrandList="getCarBrandList"
      ></EditForm>
    </template>
  </SettingsPageTemplate>
</template>

<script>
import SettingsPageTemplate from '@/components/settings/SettingsPageTemplate.vue';
import http from '@/config/axios';
import CustomDataTable from '@/components/customDataTable/CustomDataTable.vue';
import CreateForm from '@/components/settings/CarBrand/CreateCarBrand.vue';
import EditForm from '@/components/settings/CarBrand/EditCarBrand.vue';

export default {
  components: {
    SettingsPageTemplate,
    CustomDataTable,
    CreateForm,
    EditForm
  },
  data() {
    return {
      isLoading: true,
      carTypeList: [],
      carBrandList: [],
      paginatedCarBrandList: [],
      dataOnEdit: {}
    };
  },
  mounted() {
    this.getCarTypeList();
    this.getCarBrandList();
  },
  methods: {
    getCarTypeList() {
      this.isLoading = true;
      http
        .get('v2/settings/car-types')
        .then((response) => {
          if (response.status == 200) {
            this.carTypeList = response.data.data;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCarBrandList() {
      this.isLoading = true;
      http
        .get('v2/settings/car-brands')
        .then((response) => {
          if (response.status == 200) {
            this.carBrandList = response.data.data;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchPaginatedData(paginatedData) {
      this.paginatedCarBrandList = paginatedData;
    },
    deleteCarBrand(carBrandId) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to delete this Car Brand!',
        icon: 'warning',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete!'
      }).then((result) => {
        if (result.isConfirmed) {
          http
            .delete(`v2/settings/car-brands/${carBrandId}`)
            .then((response) => {
              if (response.status == 200) {
                this.$swal('Success', response.data.message, 'success');
                this.getCarBrandList();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    }
  }
};
</script>

<style scoped></style>
